import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".CartBox-module_offerBox__3UwhL {\n  border-radius: var(--pp-radius-m, 12px);\n  background-color: var(--pp-color-special-autoshipmentLight);\n  padding: 24px 16px;\n}";
var styles = {"offerBox":"CartBox-module_offerBox__3UwhL"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=CartBox.module.scss.js.map
